import MSlice from "../../helper/MSlice";

const roleSlice = new MSlice({ name: "role" });

export const roleActions = roleSlice.getActions();

export default roleSlice.getReducer();
